import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";
import { FloatingNotificationBell } from "../components/shared/floating-notification-bell";

const NotificationContext = createContext({
  showNotificationContext: () => {},
  hideNotification: () => {},
});

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotificationContext must be used within NotificationContextProvider"
    );
  }
  return context;
};

export const NotificationContextProvider = ({ children, onBellClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState(null);

  const showNotificationContext = useCallback((data) => {
    setNotificationData(data);
    setIsVisible(true);
  }, []);

  const hideNotification = useCallback(() => {
    setIsVisible(false);
  }, []);

  const handleBellClick = useCallback(() => {
    if (notificationData && onBellClick) {
      onBellClick(notificationData);
    }
    setIsVisible(false);
  }, [notificationData, onBellClick]);

  return (
    <NotificationContext.Provider
      value={{ showNotificationContext, hideNotification }}>
      {children}
      <FloatingNotificationBell
        isVisible={isVisible}
        title={notificationData?.title}
        body={notificationData?.body}
        variant={notificationData?.variant || "success"}
        onClick={handleBellClick}
      />
    </NotificationContext.Provider>
  );
};
